import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.3ds.sms.title',
        defaultMessage: 'SMS',
    },
    contact: {
        id: 'modal.3ds.sms.contact',
        defaultMessage: 'Contact support',
    },
    close: {
        id: 'modal.3ds.sms.close',
        defaultMessage: 'Close',
    },
    description: {
        id: 'modal.3ds.sms.description',
        defaultMessage:
            'A one-time code is sent to the phone number used when this card was created. Enter it on the payment page to confirm. Works without an app or internet connection.<br/><br/>If your phone number has changed since you got this card, contact support to update it.',
    },
})
